import vEmailDoubleValidation from "./v-email-double-validation.vue";

export default Vue => {
  Vue.component("v-email-double-validation", vEmailDoubleValidation);
};
